import filterObjectProperties from "../../__internal__/filter-object-properties";
export const layoutPropertyNames = ["width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "size", "display", "verticalAlign", "overflow", "overflowX", "overflowY", "position", "top", "right", "bottom", "left"];
export default function filterStyledSystemLayoutProps(originalObject) {
  return filterObjectProperties(originalObject, layoutPropertyNames);
}